var defaultValues = function defaultValues(fields) {
  var form = {};
  fields.forEach(function (field) {
    var type = field.type.toLowerCase();

    if (type === 'multiselect') {
      form["input_".concat(field.id)] = [];
    } else {
      form["input_".concat(field.id)] = '';
    }
  });
  return form;
};

export default defaultValues;